import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { model as catchupsModel } from '~/entities/catchups'
import { ModuleAppTitle } from '~/features/appearance'
import { STATIC_IDENTIFIERS } from '~/shared/appearance'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as catchupsPageModel from './model'

export function Title(): JSX.Element {
  return (
    <ModuleAppTitle
      identifier={STATIC_IDENTIFIERS.CATCHUP}
      fallbackKey='catchup_other'
    />
  )
}

const skin = era.skin('routes/catchups/root')

CatchupsPage.displayName = 'CatchupsPage'
export function CatchupsPage(): JSX.Element {
  const catchups = useUnit(catchupsModel.$allCatchupsToDisplayFormatted)

  const isCatchupsContentLoading = useUnit(
    catchupsPageModel.$catchupsContentLoading
  )
  const isProgramsContentLoading = useUnit(
    catchupsPageModel.$programsContentLoading
  )

  const fullHeight = catchups.length ? 'full-page-height' : ''

  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className={`flex-column ${fullHeight}`}>
        <Skeleton pageType='catchups' isLoading={isCatchupsContentLoading}>
          <ui.RenderSkin name='catchupsRow' />
        </Skeleton>
        <Skeleton
          pageType='catchupsGridWithPrograms'
          isLoading={isProgramsContentLoading}
        >
          <ui.RenderSkin name='catchupsProgramsWithDateList' />
        </Skeleton>
        <ui.RenderSkin name='catchupsEmptyCatalogPage' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
